// Report metadata for frontend
export const REPORTS = [
  {
    id: "vedic",
    title: "AI Vedic Astrology Report",
    icon: "sparkles",
    tagline: "A complete AI-generated birth chart analysis based on your date, time, and place of birth.",
    includes: [
      "Birth Chart (Kundli) Analysis", "Planetary Positions", "Career & Profession",
      "Business Growth", "Love & Relationships", "Marriage Prospects",
      "Finance & Wealth", "Health Overview", "Education", "Foreign Travel",
      "Strengths & Challenges", "Lucky Number", "Lucky Color", "Lucky Gemstone",
      "Personalized AI Guidance"
    ],
    fields: [
      { key: "name", label: "Full Name", type: "text", required: true },
      { key: "gender", label: "Gender", type: "select", options: ["Male", "Female", "Other"], required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
      { key: "tob", label: "Time of Birth", type: "time", required: true },
      { key: "pob", label: "Place of Birth (City, Country)", type: "text", required: true },
    ],
  },
  {
    id: "palmistry",
    title: "AI Palmistry Report",
    icon: "hand",
    tagline: "Upload clear photos of your left and right palms for an AI-powered palm reading.",
    includes: [
      "Life Line Analysis", "Heart Line Analysis", "Head Line Analysis",
      "Fate Line Analysis", "Sun Line Analysis", "Marriage Line", "Money Line",
      "Health Line", "Career Potential", "Relationship Insights", "Financial Outlook",
      "AI Palm Image Analysis", "Personalized Summary"
    ],
    fields: [
      { key: "name", label: "Full Name", type: "text", required: true },
      { key: "gender", label: "Gender", type: "select", options: ["Male", "Female", "Other"], required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
      { key: "palm_left", label: "Left Palm Photo", type: "palm-upload", required: true, side: "left" },
      { key: "palm_right", label: "Right Palm Photo", type: "palm-upload", required: true, side: "right" },
    ],
  },
  {
    id: "tarot",
    title: "AI Tarot Reading",
    icon: "layout",
    tagline: "Receive AI-generated tarot guidance based on your selected question or life area.",
    includes: ["AI Card Selection", "Card Meanings", "Personalized Interpretation", "Guidance & Next Steps"],
    fields: [
      { key: "name", label: "Your Name", type: "text", required: true },
      { key: "focus", label: "Focus Area", type: "select", options: ["General Guidance", "Love", "Career", "Business", "Finance", "Health", "Family", "Future Path"], required: true },
      { key: "question", label: "Your Question", type: "textarea", required: true },
    ],
  },
  {
    id: "numerology",
    title: "AI Numerology Report",
    icon: "hash",
    tagline: "Personalized numerology report based on your name and date of birth.",
    includes: ["Life Path Number", "Destiny Number", "Soul Number", "Personality Number", "Expression Number", "Lucky Number", "Lucky Dates", "Lucky Colors", "Career Insights", "Relationship Compatibility", "Personal Growth Guidance"],
    fields: [
      { key: "name", label: "Full Name (as on birth certificate)", type: "text", required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
    ],
  },
  {
    id: "love",
    title: "AI Love & Relationship Report",
    icon: "heart",
    tagline: "Understand your emotional patterns and relationship compatibility.",
    includes: ["Love Life Analysis", "Relationship Compatibility", "Emotional Strengths", "Marriage Potential", "Communication Style", "Future Relationship Trends", "Personalized Advice"],
    fields: [
      { key: "name", label: "Full Name", type: "text", required: true },
      { key: "gender", label: "Gender", type: "select", options: ["Male", "Female", "Other"], required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
      { key: "tob", label: "Time of Birth", type: "time", required: false },
      { key: "pob", label: "Place of Birth", type: "text", required: true },
      { key: "relationship_status", label: "Relationship Status", type: "select", options: ["Single", "Dating", "Engaged", "Married", "Complicated"], required: true },
    ],
  },
  {
    id: "career",
    title: "AI Career & Business Report",
    icon: "briefcase",
    tagline: "Discover career opportunities and business growth potential.",
    includes: ["Career Direction", "Business Success Indicators", "Leadership Strengths", "Financial Opportunities", "Job Change Analysis", "Professional Growth", "Skill Development Suggestions"],
    fields: [
      { key: "name", label: "Full Name", type: "text", required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
      { key: "tob", label: "Time of Birth", type: "time", required: false },
      { key: "pob", label: "Place of Birth", type: "text", required: true },
      { key: "current_role", label: "Current Role / Situation", type: "text", required: false },
    ],
  },
  {
    id: "wealth",
    title: "AI Wealth & Finance Report",
    icon: "coins",
    tagline: "AI-powered financial guidance based on astrology and numerology.",
    includes: ["Wealth Potential", "Financial Strengths", "Saving & Investment Guidance", "Income Growth Opportunities", "Business Finance Outlook", "Money Management Tips", "Prosperity Recommendations"],
    fields: [
      { key: "name", label: "Full Name", type: "text", required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
      { key: "tob", label: "Time of Birth", type: "time", required: false },
      { key: "pob", label: "Place of Birth", type: "text", required: true },
    ],
  },
  {
    id: "compatibility",
    title: "AI Compatibility Report",
    icon: "users",
    tagline: "Compare two people for relationship, marriage, friendship or business compatibility.",
    includes: ["Compatibility Score", "Emotional Compatibility", "Communication Analysis", "Relationship Strengths", "Challenges", "Long-Term Potential", "AI Recommendations"],
    fields: [
      { key: "name_a", label: "Person A — Name", type: "text", required: true },
      { key: "dob_a", label: "Person A — DOB", type: "date", required: true },
      { key: "pob_a", label: "Person A — Place of Birth", type: "text", required: true },
      { key: "name_b", label: "Person B — Name", type: "text", required: true },
      { key: "dob_b", label: "Person B — DOB", type: "date", required: true },
      { key: "pob_b", label: "Person B — Place of Birth", type: "text", required: true },
      { key: "type", label: "Compatibility Type", type: "select", options: ["Romantic", "Marriage", "Friendship", "Business"], required: true },
    ],
  },
  {
    id: "lucky",
    title: "AI Lucky Number, Color & Gemstone",
    icon: "star",
    tagline: "Personalized lucky numbers, colors, gemstones and days.",
    includes: ["Lucky Numbers", "Lucky Colors", "Lucky Days", "Lucky Gemstones", "Auspicious Dates", "Positive Energy Suggestions"],
    fields: [
      { key: "name", label: "Full Name", type: "text", required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
      { key: "pob", label: "Place of Birth", type: "text", required: false },
    ],
  },
  {
    id: "yearly",
    title: "AI Yearly Horoscope Report",
    icon: "calendar",
    tagline: "A detailed AI prediction covering the next 12 months.",
    includes: ["Year Overview", "Monthly Highlights", "Career Forecast", "Business Outlook", "Finance Forecast", "Love & Relationships", "Marriage", "Health", "Education", "Travel", "Important Dates", "Opportunities & Challenges", "Lucky Months", "Personalized Yearly Guidance"],
    fields: [
      { key: "name", label: "Full Name", type: "text", required: true },
      { key: "dob", label: "Date of Birth", type: "date", required: true },
      { key: "tob", label: "Time of Birth", type: "time", required: false },
      { key: "pob", label: "Place of Birth", type: "text", required: true },
    ],
  },
];

export const FREE_TOOLS = [
  { id: "daily-horoscope", label: "Daily Horoscope", desc: "Personal cosmic forecast for today", size: "lg" },
  { id: "weekly-horoscope", label: "Weekly Horoscope", desc: "7-day zodiac forecast", size: "md" },
  { id: "monthly-horoscope", label: "Monthly Horoscope", desc: "This month's cosmic wave", size: "md" },
  { id: "zodiac-signs", label: "12 Zodiac Sign Guides", desc: "Deep dive into each sign", size: "md" },
  { id: "birth-chart", label: "Birth Chart (Kundli)", desc: "Instant kundli", size: "md" },
  { id: "moon-sign", label: "Moon Sign Calculator", desc: "Find your emotional sign", size: "sm" },
  { id: "ascendant", label: "Ascendant (Lagna)", desc: "Your rising sign", size: "sm" },
  { id: "nakshatra", label: "Nakshatra Finder", desc: "27 lunar mansions", size: "sm" },
  { id: "numerology", label: "Numerology Calculator", desc: "Life-path in seconds", size: "md" },
  { id: "life-path", label: "Life Path Number", desc: "Your purpose in a digit", size: "sm" },
  { id: "compatibility", label: "Compatibility Check", desc: "Two-person love score", size: "md" },
  { id: "lucky-number", label: "Lucky Number", desc: "Personal lucky digits", size: "sm" },
  { id: "lucky-color", label: "Lucky Color Finder", desc: "Your color of fortune", size: "sm" },
  { id: "gemstone", label: "Gemstone Finder", desc: "Your birth gemstone", size: "sm" },
  { id: "tarot-day", label: "Tarot Card of the Day", desc: "Today's tarot draw", size: "md" },
  { id: "panchang", label: "Panchang Today", desc: "Tithi, Nakshatra, Yoga", size: "md" },
  { id: "muhurat", label: "Muhurat Finder", desc: "Auspicious timing", size: "sm" },
  { id: "festivals", label: "Festival Calendar", desc: "Hindu festival dates", size: "md" },
];
